<template>
  <b-sidebar
    id="sidebar-snapshot-approver"
    sidebar-class="sidebar-lg"
    :visible="approverSidebar.visible"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
    @change="(val) => mutateApproverSidebar({ visible: val })"
    @hidden="clear"
    @shown="onShow"
  >
    <template #default="{ hide }">
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h4 class="mb-0">Novo aprovador</h4>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
      <b-form class="p-2" @submit.prevent="onSubmit">
        <b-form-group label="Usuário" label-for="snapshot-approver-user">
          <v-select
            id="snapshot-approver-user"
            v-model="userId"
            :options="candidates"
            :reduce="(user) => user.id"
            :loading="loading"
            :disabled="saving"
            label="name"
            :class="getSelectErrorClass(v$.userId.$error)"
          >
            <template #no-options>Sem resultados</template>
          </v-select>
          <div class="invalid-feedback">
            <span v-if="v$.userId.$error">
              Você deve selecionar um usuário
            </span>
          </div>
        </b-form-group>
        <div class="d-flex mt-2">
          <b-button
            :disabled="saving"
            variant="primary"
            class="mr-2"
            type="submit"
          >
            {{ saving ? "Salvando..." : "Salvar" }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import { BSidebar, BForm, BFormGroup, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import { mapMutations, mapGetters, mapActions } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { apiErrorToast } from "@/helpers/error_messages";
import { getVueSelectErrorClass } from "@/helpers/validators";
import * as types from "../store/types";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    vSelect,
  },
  setup() {
    return { toast: useToast(), v$: useVuelidate() };
  },
  data() {
    return {
      loading: false,
      saving: false,
      candidates: [],
      userId: undefined,
    };
  },
  validations() {
    return {
      userId: { required },
    };
  },
  computed: {
    ...mapGetters({
      approverSidebar: types.APPROVER_SIDEBAR,
    }),
  },
  methods: {
    ...mapMutations({
      mutateApproverSidebar: types.MUTATE_APPROVER_SIDEBAR,
    }),
    ...mapActions({
      getApproverCandidates: types.GET_APPROVER_CANDIDATES,
      addApprover: types.ADD_APPROVER,
    }),
    async onSubmit() {
      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) return;
      this.saving = true;
      this.addApprover(this.userId)
        .then(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Sucesso",
              text: "Aprovador incluído com sucesso!",
              icon: "CoffeeIcon",
              variant: "success",
            },
          });
          this.mutateApproverSidebar({ visible: false });
          this.approverSidebar.saveAction();
        })
        .catch((error) => {
          this.toast({
            component: ToastificationContent,
            props: apiErrorToast(
              error,
              "Ocorreu um erro ao incluir o aprovador. Entre em contato com o setor de TI."
            ),
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    onShow() {
      this.loading = true;
      this.getApproverCandidates()
        .then((response) => {
          this.candidates = response.data;
        })
        .catch((error) => {
          this.toast({
            component: ToastificationContent,
            props: apiErrorToast(
              error,
              "Ocorreu um erro ao carregar os usuários. Entre em contato com o setor de TI."
            ),
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clear() {
      this.userId = undefined;
      this.candidates = [];
      this.v$.$reset();
    },
    getSelectErrorClass(thereIsError) {
      return getVueSelectErrorClass(thereIsError);
    },
  },
};
</script>
